import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

export const FormError: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div data-testid="leave-contacts-modal-error">
      <Body2 color="text-negative-default">{children}</Body2>
    </div>
  );
};
